import Vue from 'vue';
import Router from 'vue-router';

import Auth from './views/auth/Auth.vue';
import Verify from './views/auth/Verify.vue';
import ResetPassword from './views/auth/ResetPassword.vue';

import TPlayer from './views/player/TimelapsePlayer.vue';

import PageNotFound from './components/errors/PageNotFound.vue';
import ServerError from './components/errors/ServerError.vue';
import AccessForbidden from './components/errors/AccessForbidden.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/timelapse',
      name: 'timelapsePlayer',
      component: TPlayer
    },

    {
      path: '/auth',
      name: 'auth',
      component: Auth,

      children: [
        {
          path: 'verify/:id',
          name: 'verify',
          component: Verify,
          props: true
        },
        {
          path: 'resetpassword/:code',
          name: 'resetpassword',
          component: ResetPassword,
          props: true
        }
      ]
    },

    {
      path: '/404',
      component: PageNotFound,
      name: '404'
    },
    {
      path: '/403',
      component: AccessForbidden,
      name: '403'
    },
    {
      path: '/500',
      component: ServerError,
      name: '500'
    },
    {
      path: '*',
      component: PageNotFound
    }

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ]
});
